import React,{ useRef } from 'react';
import { 
    Show,
    SimpleShowLayout,
    ListButton,
    CardActions
} from 'react-admin';
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles';
import ReactToPrint from "react-to-print";
import PrintIcon from '@material-ui/icons/Print';
import SamplePrint from './SamplePrint';
import ErrorBoundary from '../ErrorBoundary';

const useStyles = makeStyles({
    root: { 
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800',
        alignItems: 'middle'
    },
    title :{
        display: 'inline-block', 
        margin: '0px 20px 5px 30px', 
        
        zIndex: 2,
        width: '100%',
        maxWidth: '700px',
        alignItems: 'middle',
        border: '1px solid gray',
        borderRadius: '20px',
        textAlign: 'center'
    },

    body :{
        display: 'inline-block', 
        margin: '5px 20px 5px 35px', 
        
        zIndex: 2,
        width: '100%',
        maxWidth: '700px',
        alignItems: 'middle',
        border: '0',
        fontSize: '12px',
        textAlign: 'left'
    },
    p: {
        fontSize: '12px',
    },
    printButton: {
        backgroundColor: '#3f51b5',
        "&:hover": {
            backgroundColor: 'navy'
        },
        textAlign: 'center', 
        verticallAign: 'middle',
        borderRadius: '10px',
        color: 'white',
        fontWeight: 'bold',
        float: 'left',
        width: '6em',
        marginTop: '1em',
        marginLeft: '30px',
        marginBottom: '1em',
       
    }
})


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};
const SampleActions = ({basePath}) => (
    <CardActions style={cardActionStyle}>
        <ListButton  
        label='Sample List' 
        basePath={basePath}
        />
    </CardActions>
);


const Print = ({record}) => {
    const componentRef = useRef();
    const classes = useStyles();
    return (
      <div>
            <SamplePrint record={record} classes={classes} ref={componentRef} />
            <ReactToPrint
            trigger={() => <button className={classes.printButton} > {<PrintIcon />} </button>}
            content={() => componentRef.current}
            />
      </div>
    );
  };


const SampleView= ({ classes, ...props }) => (
<ErrorBoundary>  
    <Show
    {...props}
    /* disable the app title change when shown */
    title="Sample View "
    actions={<SampleActions />} 
    >
    <SimpleShowLayout>
    <Print />
    </SimpleShowLayout>
</Show>
</ErrorBoundary>  
)

export default SampleView